import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileBookingBar from "./components/MobileBookingBar";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* Optional skip link for accessibility */}
        <a className="skip-link" href="#main">Skip to content</a>

        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />

        {/* Mobile booking bar (mobile only) */}
        <MobileBookingBar />
      </BrowserRouter>
    </div>
  );
}

export default App;